import {
  getUpcomingAuctions,
  getUpcomingSubEvent,
} from 'services/graphql/queries/auctions/formatedAuctions';
import AuctionsCardList from 'components/AuctionsCardList';
import React from 'react';
import { useStaticQueryGetAuctions } from 'services/graphql/queries/auctions';
import moment from 'moment';
import {
  getEventDateAverage,
  getEventTimeAverage,
} from 'shared/helpers/auctions';
import { isOnlineAuction } from 'src/utils/auctionTypes';
import { AUCTION_PATH } from 'src/utils/pathsConstants';

const UpcomingAuctions = ({ fullWidth, auctionType, details, auctionData }) => {
  const { subEventAuction } = useStaticQueryGetAuctions({
    variables: {
      todayDate: moment().format('YYYY-MM-DDTHH:mm'),
    },
  });
  const validSubEvents =
    subEventAuction?.length && getUpcomingSubEvent(subEventAuction);

  const auctions =
    validSubEvents?.length &&
    getUpcomingAuctions(validSubEvents)
      .filter(
        auction =>
          auction.webpage__auction &&
          auction?.name !== auctionData?.auction?.name
      )
      .map(auction => {
        return {
          name: auction.name,
          backgroundImage:
            auction.webpage__auction[0]?.featureImage?.fluid || '',
          date:
            (auction.subEvents?.length &&
              getEventDateAverage(
                auction.subEvents,
                auction.conditionsOfSaleType.split(' ')[0] !== 'UK'
              )) ||
            `${auction.modelYear ? auction.modelYear : ''} ${
              auction.make?.name ? auction.make.name : ''
            } ${auction.model ? auction.model : ''}`,
          buttons: [
            {
              text: details ? 'Learn More' : 'Event Details',
              slug: AUCTION_PATH(auction.webpage__auction[0]?.slug || ''),
            },
          ],
          time: '',
          mode: auction.eventAttendanceMode,
          type: auction.conditionsOfSaleType,
          status: auction.eventStatus,
        };
      })
      .filter(auction => auction?.status !== 'EventCancelled');
  return (
    <>
      {!!auctions?.length && (
        <AuctionsCardList
          details={details}
          fullWidth={fullWidth}
          auctions={
            auctionType === 'online'
              ? auctions?.length &&
                auctions.filter(auction => isOnlineAuction(auction?.mode))
              : auctions
          }
          subEventAuction={validSubEvents}
          title={'Upcoming Auctions'}
        />
      )}
    </>
  );
};

export default UpcomingAuctions;
